/** Report unique code for the PRM Detailed Report */
export const PRM_REPORT_UNIQUE_CODE = 'PRM_DETAILED';
